import { Link } from "react-router-dom";
import { COMPANY, NAV_LINKS } from "../data/siteData";

export default function Footer() {
  return (
    <footer className="bg-[#050912] border-t border-slate-800 text-slate-400 text-sm">
      {/* Main Footer Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Col 1: Brand & Positioning */}
          <div className="space-y-4">
            <Link to="/" className="inline-block group py-1" aria-label="KVC Express ApS">
              <img
                src="https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/kvc-nyt-logo-2.png"
                alt="KVC Express ApS Logo"
                className="h-10 w-auto max-w-[220px] object-contain transition-transform duration-200 group-hover:scale-[1.02]"
              />
            </Link>
            <p className="text-xs text-slate-400 leading-relaxed">
              Professionel og stabil køle- og medicinaltransport for erhvervskunder. Vi leverer i hele Danmark inkl. Bornholm.
            </p>
            <div className="pt-2 flex flex-wrap items-center gap-2">
              <div className="inline-block bg-slate-900 border border-slate-800 rounded-md px-3 py-1 text-[11px] font-mono text-slate-300">
                CVR: <span className="text-white font-semibold">{COMPANY.cvr}</span>
              </div>
              <div className="inline-flex items-center gap-1.5 bg-[#0F766E]/20 border border-[#2DD4BF]/30 rounded-md px-2.5 py-1 text-[11px] font-mono text-[#2DD4BF]">
                <i className="fa-solid fa-map-location-dot text-[10px]" aria-hidden="true" />
                <span>Hele Danmark inkl. Bornholm</span>
              </div>
            </div>
          </div>

          {/* Col 2: Ydelser */}
          <div>
            <h4 className="text-xs font-mono uppercase tracking-widest text-slate-200 font-bold mb-4">
              Ydelser & Områder
            </h4>
            <ul className="space-y-2.5 text-xs">
              {NAV_LINKS[0].dropdown.map((sub) => (
                <li key={sub.href}>
                  <Link
                    to={sub.href}
                    className="hover:text-[#2DD4BF] transition flex items-center gap-2 group"
                  >
                    <i className="fa-solid fa-angle-right text-[10px] text-slate-600 group-hover:text-[#2DD4BF] transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
                    <span>{sub.title}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Navigation */}
          <div>
            <h4 className="text-xs font-mono uppercase tracking-widest text-slate-200 font-bold mb-4">
              Virksomheden
            </h4>
            <ul className="space-y-2.5 text-xs">
              <li>
                <Link to="/om-kvc-express" className="hover:text-[#2DD4BF] transition flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-slate-600 group-hover:text-[#2DD4BF] transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
                  <span>Om KVC Express</span>
                </Link>
              </li>
              <li>
                <Link to="/vores-koeretoejer" className="hover:text-[#2DD4BF] transition flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-slate-600 group-hover:text-[#2DD4BF] transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
                  <span>Vores køretøjer</span>
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-[#2DD4BF] transition flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-slate-600 group-hover:text-[#2DD4BF] transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
                  <span>Kontakt</span>
                </Link>
              </li>
              <li>
                <Link to="/privatlivspolitik" className="hover:text-[#2DD4BF] transition flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-slate-600 group-hover:text-[#2DD4BF] transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
                  <span>Privatlivspolitik</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Virksomhedsoplysninger */}
          <div>
            <h4 className="text-xs font-mono uppercase tracking-widest text-slate-200 font-bold mb-4">
              Kontakt & Lokation
            </h4>
            <div className="space-y-3 text-xs">
              <div className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot text-[#2DD4BF] mt-0.5 text-xs" aria-hidden="true" />
                <span className="text-slate-300 leading-relaxed">
                  <strong className="text-white font-semibold">{COMPANY.location}</strong><br />
                  <span className="text-slate-400">{COMPANY.coverage}</span>
                </span>
              </div>
              <div className="flex items-start gap-2.5">
                <i className="fa-solid fa-phone text-[#2DD4BF] text-xs mt-1" aria-hidden="true" />
                <div>
                  <a
                    href={`tel:${COMPANY.phoneRaw}`}
                    className="text-slate-300 hover:text-white transition whitespace-nowrap block"
                  >
                    <span className="whitespace-nowrap font-semibold">{COMPANY.phone}</span>
                  </a>
                  <span className="text-[11px] text-slate-400 block">{COMPANY.phoneHours}</span>
                </div>
              </div>
              <div className="flex items-start gap-2.5">
                <i className="fa-solid fa-envelope text-[#2DD4BF] text-xs mt-1" aria-hidden="true" />
                <div>
                  <a
                    href={`mailto:${COMPANY.email}`}
                    className="text-slate-300 hover:text-white transition whitespace-nowrap block"
                  >
                    <span className="whitespace-nowrap">{COMPANY.email}</span>
                  </a>
                  <span className="text-[11px] text-slate-400 block">{COMPANY.emailResponse}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-900 bg-[#03060c] py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>© {new Date().getFullYear()} {COMPANY.name} · CVR {COMPANY.cvr} · Alle rettigheder forbeholdes.</span>
            <Link to="/privatlivspolitik" className="hover:text-slate-300 transition underline underline-offset-4">
              Privatlivspolitik
            </Link>
          </div>
          <div className="font-mono text-[11px] text-slate-500">
            Specialiseret B2B Køletransport & Pharma Logistik
          </div>
        </div>
      </div>
    </footer>
  );
}
